/**
 * Flow overlay list sorting — flow order vs optimizer rank.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowLayer } from '@trafficpulse/shared';

import type { FlowPreviewRankLookups } from '@/features/flow-optimizer/components/preview/flow-preview-ranks';
import {
  maxRankForFilter,
  type PreviewRankFilter,
} from '@/features/flow-optimizer/components/preview/preview-sort';

export type FlowOverlayListSortMode = 'flow' | 'rank';

export interface SortFlowOverlayItemsParams {
  mode: FlowOverlayListSortMode;
  rankFilter: PreviewRankFilter;
  lookups: FlowPreviewRankLookups;
  layer: FlowLayer;
  pathId?: string;
}

export function sortFlowOverlayItems<T extends { id: string }>(
  items: readonly T[],
  params: SortFlowOverlayItemsParams,
): T[] {
  if (params.mode === 'flow') return [...items];
  const getRank = (id: string) => params.lookups.get(params.layer, id, params.pathId);
  const sorted = [...items].sort((a, b) => {
    const rankA = getRank(a.id) ?? Number.MAX_SAFE_INTEGER;
    const rankB = getRank(b.id) ?? Number.MAX_SAFE_INTEGER;
    return rankA - rankB;
  });
  const maxRank = maxRankForFilter(params.rankFilter);
  if (maxRank == null) return sorted;
  return sorted.filter((item) => (getRank(item.id) ?? Number.MAX_SAFE_INTEGER) <= maxRank);
}
